(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-artwork-template"]) return;
  try {
    

function nextproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--next').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
function previousproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--previous').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
window.addEventListener("keydown", function (event) {
  if (event.defaultPrevented) {
    return; // Do nothing if the event was already processed
  }

  switch (event.key) {
    case "Left": // IE/Edge specific value
    case "ArrowLeft":
      previousproduct();
      break;
    case "Right": // IE/Edge specific value
    case "ArrowRight":
      nextproduct();
	  break;
    case "Esc": // IE/Edge specific value
    case "Escape":
      // Do something for "esc" key press.
      break;
    default:
      return; // Quit when this doesn't handle the key event.
  }

  event.preventDefault();
}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collaborator-template"]) return;
  try {
    

function nextproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--next').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
function previousproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--previous').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
window.addEventListener("keydown", function (event) {
  if (event.defaultPrevented) {
    return; // Do nothing if the event was already processed
  }

  switch (event.key) {
    case "Left": // IE/Edge specific value
    case "ArrowLeft":
      previousproduct();
      break;
    case "Right": // IE/Edge specific value
    case "ArrowRight":
      nextproduct();
	  break;
    case "Esc": // IE/Edge specific value
    case "Escape":
      // Do something for "esc" key press.
      break;
    default:
      return; // Quit when this doesn't handle the key event.
  }

  event.preventDefault();
}, true);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-old"]) return;
  try {
    


$('a[data-variant-title]').on('click',function(e){
	$('select#SingleOptionSelector-0').val($(this).data('variant-title')).change();
});
$('a[data-thumbnail-id]').on('click',function(e){
	e.preventDefault();
	$('.product-single__photos').get(0).scrollIntoView({behavior: "smooth", block: "start", inline: "center"})
});

$('.product-single__photo-wrapper').on('click',function(e){
	rect = e.target.getBoundingClientRect();
    x = (e.clientX - rect.left)/rect.width;
    y = (e.clientY - rect.top)/rect.height;

	if(x > 0.05){ 
		$('li:has(.product-single__thumbnail.active-thumb)').first().next().children('a').click()
	}


})	


function nextproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--next').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
function previousproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--previous').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
window.addEventListener("keydown", function (event) {
  if (event.defaultPrevented) {
    return; // Do nothing if the event was already processed
  }

  switch (event.key) {
    case "Left": // IE/Edge specific value
    case "ArrowLeft":
      previousproduct();
      break;
    case "Right": // IE/Edge specific value
    case "ArrowRight":
      nextproduct();
	  break;
    case "Esc": // IE/Edge specific value
    case "Escape":
      // Do something for "esc" key press.
      break;
    default:
      return; // Quit when this doesn't handle the key event.
  }

  event.preventDefault();
}, true);

/*

function swipedetect(el, callback){
  
    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, // required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){}
  
    touchsurface.addEventListener('touchstart', function(e){
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        e.preventDefault()
    }, false)
  
    touchsurface.addEventListener('touchmove', function(e){
        e.preventDefault() // prevent scrolling when inside DIV
    }, false)
  
    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)
        e.preventDefault()
    }, false)
}
  
//USAGE:
if( false || (el = document.getElementsByClassName('product-single')[0]) ){
swipedetect(el, function(swipedir){
	console.log(swipedir);
	switch(swipedir){
		case 'left': 
			previousproduct();
			break;
		case 'right': 
			nextproduct();
			break;
		default:
			return;
	}
});
}
*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-slider"]) return;
  try {
    


$('a[data-variant-title]').on('click',function(e){
	$('select#SingleOptionSelector-0').val($(this).data('variant-title')).change();
	$('.product-single__photos').get(0).scrollIntoView({behavior: "smooth", block: "start", inline: "center"})
});



function nextproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--next').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
function previousproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--previous').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
window.addEventListener("keydown", function (event) {
  if (event.defaultPrevented) {
    return; // Do nothing if the event was already processed
  }

  switch (event.key) {
    case "Left": // IE/Edge specific value
    case "ArrowLeft":
      previousproduct();
      break;
    case "Right": // IE/Edge specific value
    case "ArrowRight":
      nextproduct();
	  break;
    case "Esc": // IE/Edge specific value
    case "Escape":
      // Do something for "esc" key press.
      break;
    default:
      return; // Quit when this doesn't handle the key event.
  }

  event.preventDefault();
}, true);

/*

function swipedetect(el, callback){
  
    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, // required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){}
  
    touchsurface.addEventListener('touchstart', function(e){
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        e.preventDefault()
    }, false)
  
    touchsurface.addEventListener('touchmove', function(e){
        e.preventDefault() // prevent scrolling when inside DIV
    }, false)
  
    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)
        e.preventDefault()
    }, false)
}
  
//USAGE:
if( false || (el = document.getElementsByClassName('product-single')[0]) ){
swipedetect(el, function(swipedir){
	console.log(swipedir);
	switch(swipedir){
		case 'left': 
			previousproduct();
			break;
		case 'right': 
			nextproduct();
			break;
		default:
			return;
	}
});
}
*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    


$('a[data-variant-title]').on('click',function(e){
	$('select#SingleOptionSelector-0').val($(this).data('variant-title')).change();
});
$('a[data-thumbnail-id]').on('click',function(e){
	e.preventDefault();
	$('.product-single__photos').get(0).scrollIntoView({behavior: "smooth", block: "start", inline: "center"})
});

$('.product-single__photo-wrapper').on('click',function(e){
	rect = e.target.getBoundingClientRect();
    x = (e.clientX - rect.left)/rect.width;
    y = (e.clientY - rect.top)/rect.height;

	if(x > 0.05){ 
		$('li:has(.product-single__thumbnail.active-thumb)').first().next().children('a').click()
	}


})	


function nextproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--next').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
function previousproduct(){
	  if(window.jQuery === $ && (btn = $('.btn--previous').get(0)) ){$('#PageContainer').fadeOut(200,function(){window.location=btn.href})}      
}
window.addEventListener("keydown", function (event) {
  if (event.defaultPrevented) {
    return; // Do nothing if the event was already processed
  }
  if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey){
    return;
  }
  
  switch (event.key) {
    case "Left": // IE/Edge specific value
    case "ArrowLeft":
       previousproduct();
      break;
    case "Right": // IE/Edge specific value
    case "ArrowRight":
      nextproduct();
	  break;
    case "Esc": // IE/Edge specific value
    case "Escape":
      // Do something for "esc" key press.
      break;
    default:
      return; // Quit when this doesn't handle the key event.
  }

  event.preventDefault();
}, true);

/*

function swipedetect(el, callback){
  
    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, // required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){}
  
    touchsurface.addEventListener('touchstart', function(e){
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        e.preventDefault()
    }, false)
  
    touchsurface.addEventListener('touchmove', function(e){
        e.preventDefault() // prevent scrolling when inside DIV
    }, false)
  
    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)
        e.preventDefault()
    }, false)
}
  
//USAGE:
if( false || (el = document.getElementsByClassName('product-single')[0]) ){
swipedetect(el, function(swipedir){
	console.log(swipedir);
	switch(swipedir){
		case 'left': 
			previousproduct();
			break;
		case 'right': 
			nextproduct();
			break;
		default:
			return;
	}
});
}
*/


  } catch(e) { console.error(e); }
})();
})();
